/* src/routes/index.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	add_render_callback,
	add_resize_listener,
	append,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	outro_and_destroy_block,
	safe_not_equal,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out,
	update_keyed_each
} from "../../_snowpack/pkg/svelte/internal.js";

import { languageNames } from "../../_components/Lang/index.js";
import { session } from "../assets/runtime/app/stores.js";
import AllDone from "../../_components/AllDone.svelte.js";
import Error from "../../_components/Error.svelte.js";
import Show from "../../_components/Show.svelte.js";
import { byLatestEpisode } from "../../_components/utils.js";
import { onMount, tick, setContext } from "../../_snowpack/pkg/svelte.js";
import { writable } from "../../_snowpack/pkg/svelte/store.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

// (107:4) {:else}
function create_else_block(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_1, create_else_block_1];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*$session*/ ctx[4].message) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (111:8) {:else}
function create_else_block_1(ctx) {
	let alldone;
	let current;
	alldone = new AllDone({});

	return {
		c() {
			create_component(alldone.$$.fragment);
		},
		l(nodes) {
			claim_component(alldone.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(alldone, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(alldone.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(alldone.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(alldone, detaching);
		}
	};
}

// (108:8) {#if $session.message}
function create_if_block_1(ctx) {
	let error;
	let current;

	error = new Error({
			props: { message: /*$session*/ ctx[4].message }
		});

	return {
		c() {
			create_component(error.$$.fragment);
		},
		l(nodes) {
			claim_component(error.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(error, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const error_changes = {};
			if (dirty & /*$session*/ 16) error_changes.message = /*$session*/ ctx[4].message;
			error.$set(error_changes);
		},
		i(local) {
			if (current) return;
			transition_in(error.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(error.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(error, detaching);
		}
	};
}

// (105:4) {#each incompleteShows as show (show.id)}
function create_each_block(key_1, ctx) {
	let first;
	let show;
	let current;

	show = new Show({
			props: {
				show: /*show*/ ctx[9],
				accent: /*accent*/ ctx[1]
			}
		});

	return {
		key: key_1,
		first: null,
		c() {
			first = empty();
			create_component(show.$$.fragment);
			this.h();
		},
		l(nodes) {
			first = empty();
			claim_component(show.$$.fragment, nodes);
			this.h();
		},
		h() {
			this.first = first;
		},
		m(target, anchor) {
			insert(target, first, anchor);
			mount_component(show, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const show_changes = {};
			if (dirty & /*incompleteShows*/ 32) show_changes.show = /*show*/ ctx[9];
			if (dirty & /*accent*/ 2) show_changes.accent = /*accent*/ ctx[1];
			show.$set(show_changes);
		},
		i(local) {
			if (current) return;
			transition_in(show.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(show.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(first);
			destroy_component(show, detaching);
		}
	};
}

// (118:0) {#if size === 'small'}
function create_if_block(ctx) {
	let style;
	let t;

	return {
		c() {
			style = element("style");
			t = text(":root{font-size:12px}");
		},
		l(nodes) {
			style = claim_element(nodes, "STYLE", {});
			var style_nodes = children(style);
			t = claim_text(style_nodes, ":root{font-size:12px}");
			style_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, style, anchor);
			append(style, t);
		},
		d(detaching) {
			if (detaching) detach(style);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let div_resize_listener;
	let t;
	let if_block_anchor;
	let current;
	let each_value = /*incompleteShows*/ ctx[5];
	const get_key = ctx => /*show*/ ctx[9].id;

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	let each_1_else = null;

	if (!each_value.length) {
		each_1_else = create_else_block(ctx);
	}

	let if_block = /*size*/ ctx[2] === "small" && create_if_block(ctx);

	return {
		c() {
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			if (each_1_else) {
				each_1_else.c();
			}

			t = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div_nodes);
			}

			if (each_1_else) {
				each_1_else.l(div_nodes);
			}

			div_nodes.forEach(detach);
			t = claim_space(nodes);
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
			this.h();
		},
		h() {
			attr(div, "class", "grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 px-1 pb-2 sm:px-2 sm:py-2 bg-transparent");
			add_render_callback(() => /*div_elementresize_handler*/ ctx[7].call(div));
			toggle_class(div, "dark", /*theme*/ ctx[0] === "dark");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			if (each_1_else) {
				each_1_else.m(div, null);
			}

			div_resize_listener = add_resize_listener(div, /*div_elementresize_handler*/ ctx[7].bind(div));
			insert(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (dirty & /*incompleteShows, accent, $session*/ 50) {
				each_value = /*incompleteShows*/ ctx[5];
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, outro_and_destroy_block, create_each_block, null, get_each_context);
				check_outros();

				if (!each_value.length && each_1_else) {
					each_1_else.p(ctx, dirty);
				} else if (!each_value.length) {
					each_1_else = create_else_block(ctx);
					each_1_else.c();
					transition_in(each_1_else, 1);
					each_1_else.m(div, null);
				} else if (each_1_else) {
					group_outros();

					transition_out(each_1_else, 1, 1, () => {
						each_1_else = null;
					});

					check_outros();
				}
			}

			if (dirty & /*theme*/ 1) {
				toggle_class(div, "dark", /*theme*/ ctx[0] === "dark");
			}

			if (/*size*/ ctx[2] === "small") {
				if (if_block) {
					
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			if (each_1_else) each_1_else.d();
			div_resize_listener();
			if (detaching) detach(t);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

async function load({ page }) {
	let theme = "light";
	let accent = "green";
	let size = "normal";
	let lang = "en";
	const validThemes = ["light", "dark"];
	const validAccents = ["red", "yellow", "green", "blue", "indigo", "purple", "pink", "none"];
	const validSizes = ["small", "normal"];

	if (page.query.has("theme")) {
		const _theme = page.query.get("theme");

		if (validThemes.includes(_theme)) {
			theme = _theme;
		}
	}

	if (page.query.has("accent")) {
		const _accent = page.query.get("accent");

		if (validAccents.includes(_accent)) {
			accent = _accent;
		}
	}

	if (page.query.has("size")) {
		const _size = page.query.get("size");

		if (validSizes.includes(_size)) {
			size = _size;
		}
	}

	if (page.query.has("lang")) {
		const _lang = page.query.get("lang");

		if (languageNames.includes(_lang)) {
			lang = _lang;
		}
	}

	return { props: { theme, accent, size, lang } };
}

function instance($$self, $$props, $$invalidate) {
	let incompleteShows;
	let $session;
	component_subscribe($$self, session, $$value => $$invalidate(4, $session = $$value));
	let { theme = "light" } = $$props;
	let { accent = "green" } = $$props;
	let { size = "normal" } = $$props;
	let { lang = "en" } = $$props;
	setContext("lang", writable(lang));
	let divHeight;

	async function messageParentAboutResize() {
		if (typeof window !== "undefined") {
			await tick();

			window.parent.postMessage(
				JSON.stringify({
					action: "resize",
					height: document.body.scrollHeight
				}),
				"*"
			);
		}
	}

	onMount(() => {
		messageParentAboutResize();
	});

	function div_elementresize_handler() {
		divHeight = this.clientHeight;
		$$invalidate(3, divHeight);
	}

	$$self.$$set = $$props => {
		if ("theme" in $$props) $$invalidate(0, theme = $$props.theme);
		if ("accent" in $$props) $$invalidate(1, accent = $$props.accent);
		if ("size" in $$props) $$invalidate(2, size = $$props.size);
		if ("lang" in $$props) $$invalidate(6, lang = $$props.lang);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$session*/ 16) {
			$: $$invalidate(5, incompleteShows = ($session.shows || []).filter(show => show.progress !== "Complete").sort(byLatestEpisode));
		}

		if ($$self.$$.dirty & /*divHeight*/ 8) {
			$: (divHeight, messageParentAboutResize());
		}
	};

	return [
		theme,
		accent,
		size,
		divHeight,
		$session,
		incompleteShows,
		lang,
		div_elementresize_handler
	];
}

class Routes extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { theme: 0, accent: 1, size: 2, lang: 6 });
	}
}

export default Routes;
export { load };
//# sourceMappingURL=index.svelte.js.map
